import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MuiColor, { MuiColorsProps } from "components/MuiExtras/Typography/MuiColor";
import * as React from "react";

interface IProps {
    showIcon?: boolean;
}

type Props = IProps & Omit<MuiColorsProps, "variant">;

const MuiInfo: React.FC<Props> = (props) => {
    const { children, showIcon, ...rest } = props;
    return (
        <MuiColor variant="info" {...rest}>
            {
                !!showIcon
                    ? <><FontAwesomeIcon icon={faInfoCircle} fixedWidth />&nbsp;{children}</>
                    : children
            }
        </MuiColor>
    );
}

export default MuiInfo;